export class ProcessStepChemicalsDTO{
    processStep: string;
    chemicals: any = [];
}

export class MultiPlateProcessStepChemicalsDTO{
    plateids: any = [];
    processStep: string;
    chemicals: any = [];
    labid: string;
}

export class MultiBeadChipProcessStepChemicalsDTO{
    beadchipids: any = [];
    processStep: string;
    chemicals: any = [];
    labid: string;
}